import { Box, Text } from '@chakra-ui/react';

import { CustomAlert } from '@aslanpay/portal-common-lib';

import { SalaryAppliesDateCellProps } from './types';

const correctionWarning = (
  appliesDate?: string,
  futureSalaryAppliesDate?: string,
  isFutureSalaryChange?: boolean
) => {
  if (appliesDate) {
    return `Salary applies from ${appliesDate}. Any salary changes after this date will be replaced.`;
  }
  if (isFutureSalaryChange) {
    return 'Any salary changes after this date will be replaced.';
  }
  if (futureSalaryAppliesDate) {
    return `This salary will be replaced by the future salary from ${futureSalaryAppliesDate}.`;
  }
  return 'This salary will be replaced by the future salary in this file.';
};

function SalaryAppliesDateCell({
  change,
  appliesDate,
  testIdPrefix = 'salary-correction-row',
  isFutureSalaryChange,
}: SalaryAppliesDateCellProps) {
  if (change.uploadEntry?.salaryCorrection) {
    return (
      <Box data-testid={`${testIdPrefix}-${change.individual?.id}`}>
        <CustomAlert
          variant="compact"
          status="warning"
          boxShadow="none"
          title={correctionWarning(
            appliesDate,
            change.uploadEntry.futureSalaryAppliesDate,
            isFutureSalaryChange
          )}
        />
      </Box>
    );
  }

  if (appliesDate) {
    return <Text as="span">{appliesDate}</Text>;
  }

  return <Text as="span">-</Text>;
}

export default SalaryAppliesDateCell;
